<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2 pb-15">
        <gofix-card title="" class="mb-0" classHeader="p-0 m-0" classContent="mb-0" fullContent>
            <gofix-tab
                class="mt-3 mb-0 contractPropertyChildTab"
                classTabContent="min-height-auto"
                :data="tabs"
                :variableWidth="false"
                activeKey="po-inspection"
                arrows>
                <template slot="gofixTab:po-inspection">
                    <poInspection/>
                </template>
                <template slot="gofixTab:maintenance">
                    <maintenance/>
                </template>
                <template slot="gofixTab:other-sources">
                    <otherSources/>
                </template>
                <template slot="gofixTab:interim-report-per-location">
                    <interimReportPerLocation/>
                </template>
                <template slot="gofixTab:interim-report">
                    <interimReport/>
                </template>
                <template slot="gofixTab:final-report">
                    <finalReport/>
                </template>
                <template slot="gofixTab:rates-of-deduction">
                    <ratesOfDeduction/>
                </template>
            </gofix-tab>  
        </gofix-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import tabData from '@/data/_tabs';
const poInspection = () => import('./po-inspection.vue')
const maintenance = () => import('./cv-aes-consolidated.vue')
const otherSources = () => import('./other-sources.vue')
const interimReportPerLocation = () => import('./interim-report-per-location.vue')
const interimReport = () => import('./interim-report.vue')
const finalReport = () => import('./final-report.vue')
const ratesOfDeduction = () => import('./rates-of-deduction.vue')

export default {
    name: 'performance_assesment_report',
    components: {
        poInspection,
        maintenance,
        otherSources,
        interimReportPerLocation,
        interimReport,
        finalReport,
        ratesOfDeduction,
    },
    data() {
        return {
            tabs: tabData.performance_assesment_report,
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID'
        })
    }
}
</script>